const VITE_1_API_FOR_CHATBOT = import.meta.env.VITE_COM_1_API_FOR_CHATBOT;
const VITE_1_AI_CHATBOX_WIDGET = import.meta.env.VITE_COM_1_AI_CHATBOX_WIDGET;
const VITE_3_AI_CHATBOT_PLATFORM_BACKEND_API = import.meta.env.VITE_COM_3_AI_CHATBOT_PLATFORM_BACKEND_API;
const VITE_11_SUPABASE_URL = import.meta.env.VITE_SHARED_SUPABASE_URL;
const VITE_11_SUPABASE_ANON_KEY = import.meta.env.VITE_SHARED_SUPABASE_ANON_KEY;
const VITE_PORT = import.meta.env.VITE_COM_2_PORT;
const VITE_ENABLE_MOCK = import.meta.env.VITE_COM_2_ENABLE_MOCK;
const VITE_DEBUG_MODE = import.meta.env.VITE_COM_2_DEBUG_MODE;
const VITE_APP_URL = import.meta.env.VITE_SHARED_APP_URL;
const VITE_SHARED_CLOUDFLARE_TURNSTILE_SITE_KEY = import.meta.env.VITE_SHARED_CLOUDFLARE_SITE_KEY;
const VITE_ENABLE_CLOUDFLARE_TURNSTILE = import.meta.env.VITE_COM_2_ENABLE_CLOUDFLARE_TURNSTILE === 'true';
const AI_CHATBOT_PLATFORM_BACKEND_API = VITE_3_AI_CHATBOT_PLATFORM_BACKEND_API + '/api/v1'


if (!VITE_3_AI_CHATBOT_PLATFORM_BACKEND_API) {
  throw new Error('VITE_3_AI_CHATBOT_PLATFORM_BACKEND_API is not defined');
}

if (!VITE_1_API_FOR_CHATBOT) {
  throw new Error('VITE_1_API_FOR_CHATBOT is not defined');
}

if (!VITE_11_SUPABASE_URL) {
  throw new Error('VITE_11_SUPABASE_URL is not defined');
}

if (!VITE_11_SUPABASE_ANON_KEY) {
  throw new Error('VITE_11_SUPABASE_ANON_KEY is not defined');
}

if (!VITE_1_AI_CHATBOX_WIDGET) {
  throw new Error('VITE_1_AI_CHATBOX_WIDGET is not defined');
}

if (!VITE_SHARED_CLOUDFLARE_TURNSTILE_SITE_KEY) {
  throw new Error('VITE_SHARED_CLOUDFLARE_TURNSTILE_SITE_KEY is not defined');
}

export {
  VITE_3_AI_CHATBOT_PLATFORM_BACKEND_API,
  VITE_1_API_FOR_CHATBOT,
  VITE_11_SUPABASE_URL,
  VITE_11_SUPABASE_ANON_KEY,
  VITE_1_AI_CHATBOX_WIDGET,
  VITE_PORT,
  VITE_ENABLE_MOCK,
  VITE_DEBUG_MODE,
  VITE_APP_URL,
  VITE_SHARED_CLOUDFLARE_TURNSTILE_SITE_KEY,
  VITE_ENABLE_CLOUDFLARE_TURNSTILE,
  AI_CHATBOT_PLATFORM_BACKEND_API
};